import { SidePanelContent } from "../../side-panel/side-panel-content";
import { DetailsDisplay } from "../shared/details";
import { CareGap, exampleCareGaps } from "./shared";
import { CareGapRowData } from "./table-data";

export function CareGapContent({
  isImpersonating,
  ...rowContents
}: {
  isImpersonating?: boolean;
} & CareGapRowData) {
  const careGap = exampleCareGaps.find(cg => cg.id === rowContents.id);
  const sourceFileName = "demo.xml";

  return (
    <SidePanelContent
      title="Care Gap"
      sourceDocument={{
        id: careGap?.id ?? "",
        fileName: sourceFileName,
      }}
      fhirJson={isImpersonating ? JSON.stringify(careGap, null, 2) : undefined}
    >
      <CareGapDisplay careGap={careGap} tableRow={rowContents} />
    </SidePanelContent>
  );
}

function CareGapDisplay({
  careGap,
  tableRow,
}: {
  careGap: CareGap | undefined;
  tableRow: CareGapRowData;
}) {
  if (!careGap) {
    return null;
  }

  return (
    <>
      <DetailsDisplay
        details={{
          title: tableRow.name,
          code: tableRow.code,
          description: tableRow.description,
        }}
      />
    </>
  );
}
